var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 78 78",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4022 72.255C49.8369 70.6102 36.3965 65.9727 24.2118 53.7882C12.0272 41.6036 7.38998 28.1632 5.74506 21.5979C4.79976 17.825 6.50201 14.1841 9.38837 12.1224L16.9552 6.71757C21.3826 3.55516 27.5417 4.62827 30.6387 9.1017L35.4024 15.9828C37.4245 18.9037 36.7271 22.907 33.8362 24.9719L30.0377 27.6851C30.6126 29.8841 32.4006 34.4 38.0004 39.9997C43.6002 45.5995 48.116 47.3873 50.315 47.9622L53.0281 44.1636C55.0931 41.2731 59.0965 40.5753 62.0173 42.5975L68.8985 47.3613C73.3718 50.4586 74.4449 56.6173 71.2824 61.0448L65.8776 68.6117C63.8158 71.4981 60.1752 73.2004 56.4022 72.255ZM28.808 49.192C39.8887 60.2726 52.1165 64.4803 57.9817 65.95C58.8391 66.1645 59.8755 65.8314 60.5882 64.8336L65.9933 57.2667C67.0473 55.7912 66.6898 53.7381 65.1984 52.7056L58.3175 47.9418L55.4058 52.0182C54.216 53.6842 52.0154 54.9907 49.4531 54.4379C46.2551 53.7479 40.3433 51.535 33.4043 44.5959C26.4652 37.6568 24.2522 31.7451 23.5622 28.5471C23.0094 25.9848 24.316 23.7842 25.9819 22.5943L30.0582 19.6826L25.2944 12.8016C24.2621 11.3104 22.209 10.9527 20.7332 12.0068L13.1664 17.4117C12.1685 18.1245 11.8354 19.1609 12.0502 20.0182C13.5198 25.8836 17.7275 38.1115 28.808 49.192Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLogo);
export default __webpack_public_path__ + "static/media/callLogo.022e9a90223824a0e592056b32b7b8fa.svg";
export { ForwardRef as ReactComponent };